import {useEffect,useState} from 'react';
import {BASIC_MODEL_PHOTOS,basicModelPhotoUrl} from '../../../config/basicModelPhotos';
import {BED_OPTIONS} from '../design/configurator/room/beds';
type ReferencePhoto={url:string;alt:string};
// Same owner-approved configuration photos used by the “What feels right?” card.
const approvedPhotos:Record<number,ReferencePhoto>=Object.fromEntries(BASIC_MODEL_PHOTOS.map(({url,alt},choice)=>[choice,{url,alt}]));
export function useBunkReferencePhotos(){
 const [photos,setPhotos]=useState(approvedPhotos);
 useEffect(()=>{let active=true;void fetch('/api/supplier-catalog?public=1').then(r=>r.ok?r.json():null).then(data=>{
  if(!active||!data?.funnelPhotos)return;
  const valid=Object.fromEntries(Object.entries(data.funnelPhotos).filter(([key,value])=>!!BED_OPTIONS[Number(key)]&&typeof (value as ReferencePhoto)?.url==='string'&&/^https?:\/\//.test((value as ReferencePhoto).url)));
  const current=Object.fromEntries(Object.entries(valid).map(([key,value])=>[key,{...(value as ReferencePhoto),url:basicModelPhotoUrl((value as ReferencePhoto).url)}]));
  setPhotos({...approvedPhotos,...current} as Record<number,ReferencePhoto>);
 }).catch(()=>{});return()=>{active=false};},[]);
 return photos;
}
export default function BunkReferenceImages({choices,photos}:{choices:number[];photos:Record<number,ReferencePhoto>}){
 const counts=new Map<number,number>();choices.forEach(choice=>counts.set(choice,(counts.get(choice)??0)+1));
 return <span className="brp-reference-images">{Array.from(counts,([choice,count])=><span className="brp-reference-image" key={choice}>
  <img src={photos[choice]?.url??approvedPhotos[choice]?.url} alt={`Example: ${photos[choice]?.alt??BED_OPTIONS[choice]?.name}`} loading="lazy" onError={event=>{const fallback=approvedPhotos[choice]?.url;if(fallback&&event.currentTarget.getAttribute('src')!==fallback)event.currentTarget.src=fallback;}}/>
  {count>1&&<span className="brp-reference-count">×{count}</span>}
 </span>)}</span>;
}

